import CSDTable from "@cloudscape-design/components-themed/table";
import { Box, SpaceBetween } from "@cloudscape-design/components-themed";
import { COMMON_LABELS,CODE_MASTER } from "../default-constants";
import { LABELS } from "./constants";
import { ApplicationStoreInfo, CSDict } from "../../features/api-interfaces";
import { formatDateTime } from "../../utils/format";

interface StoresTableProps {
  stores: ApplicationStoreInfo[];
  appStatusCodes: CSDict[];
  appDetailStatusCodes: CSDict[];
  isDocomoUser: boolean;
  isDocomoMasterUser: boolean;
  isFetching?: boolean;
}

/**
 * 申請内容照会 店舗情報タブ
 */
export const Table = (props: StoresTableProps) => {
  const convertValueToLabel = (value: string, codeList: CSDict[]) => {
    const convertResult = codeList
      .filter((code) => code.value === value)
      .map((code) => code.label);
    return convertResult.length === 0 ? "ー" : convertResult[0];
  };

  const convertValueToLabelNotMasterUser = (
    value: string,
    codeList: CSDict[]
  ) => {
    const convertResult = codeList
      .filter((code) => code.value === value && value === "01")
      .map((code) => code.label);
    return convertResult.length === 0 ? "ー" : convertResult[0];
  };

  /**
   * 権限に応じたテーブルカラムを取得する
   */
  const getColumnItem = () => {
    if(!props.isDocomoUser){
      return columnDefinitionsBase.filter(item => item.header !== LABELS.MERCHANT_ANSWERED 
        && item.header !== LABELS.APPLICATION_DETAIL_STATUS);
    }
    if(!props.isDocomoMasterUser){
      return columnDefinitionsBase.filter(item => item.header !== LABELS.MERCHANT_ANSWERED);
      }
    return columnDefinitionsBase;
  }

  const columnDefinitionsBase = [
    {
      id: "store_name",
      header: LABELS.STORE_NAME,
      cell: (e: ApplicationStoreInfo) => (e.name ?? COMMON_LABELS.HYPHEN),
    },
    {
      id: "address",
      header: LABELS.ADDRESS,
      cell: (e: ApplicationStoreInfo) => (e.address ?? COMMON_LABELS.HYPHEN),
    },
    {
      id: "updateDifferencial",
      header: LABELS.APPLICATION_TYPE,
      cell: (e: ApplicationStoreInfo) => e.updateDifferencial,
    },
    {
      id: "application_status",
      header: LABELS.APPLICATION_STATUS,
      cell: (e: ApplicationStoreInfo) =>
        convertValueToLabel(e.applicationStatusCode, props.appStatusCodes),
    },
    {
      id: "application_detail_status",
      header: LABELS.APPLICATION_DETAIL_STATUS,
      cell: (e: ApplicationStoreInfo) =>
        props.isDocomoMasterUser
          ? convertValueToLabel(
              e.applicationDetailStatusCode,
              props.appDetailStatusCodes
            )
          : convertValueToLabelNotMasterUser(
              e.applicationDetailStatusCode,
              props.appDetailStatusCodes
            ),
    },
    {
      id: "fixedTime",
      header: LABELS.ANSWER_START_TIME,
      cell: (e: ApplicationStoreInfo) =>
        e.fixedTime === null || e.fixedTime === ""
          ? COMMON_LABELS.HYPHEN
          : formatDateTime(e.fixedTime),
    },
    {
      id: "incompletionReason",
      header: LABELS.INCOMPLETION_REASON,
      cell: (e: ApplicationStoreInfo) => e.incompletionReason,
    },
    {
      id: "merchantAnswered",
      header: LABELS.MERCHANT_ANSWERED,
      cell: (e: ApplicationStoreInfo) => e.merchantAnswered === CODE_MASTER.MERCHANT_ANSWERED_LIST[2].value
        ? LABELS.DONE : COMMON_LABELS.HYPHEN,
    },
  ];

  return (
    <CSDTable
      columnDefinitions={getColumnItem()}
      loading={props.isFetching}
      loadingText={COMMON_LABELS.CSD.LOADING_TEXT}
      trackBy="id"
      items={props.stores}
      resizableColumns
      stickyHeader
      header={
        <SpaceBetween size="xs">
          <SpaceBetween direction="horizontal" size="l"></SpaceBetween>
        </SpaceBetween>
      }
      empty={
        <Box textAlign="center" color="inherit">
          {COMMON_LABELS.CSD.NO_DATA}
        </Box>
      }
    />
  );
};

export default Table;
